import { useEffect, useState } from 'react';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Button,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Paper,
    Stack,
} from '@mui/material';

import { TopoJSON } from 'types/map';

type SelectedCounterProps = {
    selected?: number[];
    onCancel?: () => void;
    onToggle?: (id: number) => void;
    data: TopoJSON;
};

export const SelectedCounter = ({
    onCancel = () => undefined,
    onToggle = () => undefined,
    selected = [],
    data,
}: SelectedCounterProps): JSX.Element | null => {
    const [showSelected, setShowSelected] = useState(false);

    useEffect(() => {
        if (!selected.length) {
            setShowSelected(false);
        }
    }, [selected.length]);

    return selected.length ? (
        <Paper
            sx={{
                position: 'absolute',
                right: 48,
                bottom: 40,
                px: 2,
                py: 1,
                boxShadow:
                    '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
                maxWidth: '300px',
                width: '100%',
            }}
            component={Stack}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <CheckCircleOutlineIcon color="primary" sx={{ mr: 2 }} />
                <span>Выбрано: {selected.length}</span>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={onCancel}
                    sx={{ ml: 2 }}
                >
                    Отмена
                </Button>
                <IconButton
                    edge="end"
                    size="small"
                    sx={{ mr: -1 }}
                    onClick={() => setShowSelected(!showSelected)}
                >
                    {showSelected ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Stack>
            <List
                sx={{
                    maxHeight: '300px',
                    overflow: 'auto',
                    display: showSelected ? undefined : 'none',
                }}
                disablePadding
            >
                {selected.map((el) => {
                    const item = data.objects.russia.geometries.find(
                        (i) => i.properties.id === el
                    );

                    return (
                        <ListItem
                            key={el}
                            disablePadding
                            sx={{
                                minHeight: 31,
                                '.MuiIconButton-root': {
                                    display: 'none',
                                },
                                '&:hover': {
                                    '.MuiIconButton-root': {
                                        display: 'flex',
                                    },
                                },
                            }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{ width: '95%' }}
                            >
                                <ListItemText
                                    primary={item?.properties.name}
                                    sx={{ opacity: 0.8 }}
                                />
                                <IconButton
                                    edge="end"
                                    size="small"
                                    sx={{ mr: -1 }}
                                    onClick={() => onToggle(el)}
                                >
                                    <CheckCircleOutlineIcon />
                                </IconButton>
                            </Stack>
                        </ListItem>
                    );
                })}
            </List>
        </Paper>
    ) : null;
};
